// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2v_8D","selected":"Chip_selected__2xdB1"};